import styled from 'styled-components'

export const AccountContainer = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.isMobile ? '100px' : '180px')};
  width: 100%;
  height: 100%;
  padding: 1.2rem;
`

export const AccountContent = styled.div`
  display: flex;
`
